module.exports = __webpack_public_path__ + "img/SAP_9030_l.53f81e1d.jpg";